import { root } from '~/preloaded';

export const resolveRouteLink = ({ path, clanId, search }: { path?: string; clanId?: string; search: string }) => {
  if (!path) {
    return root;
  }

  let link = `${root}${path}`;

  if (clanId) {
    link = link.replace(':clanId', clanId) + search;
  }

  return link;
};
